import React, {useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Navbar, Header, Homepage, ContactUs, Analytics, HomeSubj, LearnMore } from './components';
import './App.css';

const App = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const userData = localStorage.getItem('user');

    if (userData) {
      navigate('/user-dashboard');
    }
  }, [navigate]);
  
  return (
      <div className="App">
        <div className="gradient__bg">
          <Navbar />
          <Homepage />
          <Analytics />
          <HomeSubj />
          <LearnMore />
          <ContactUs />
        </div>
      </div>

  );
};

export default App;
